import { createRouteRef, type RouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef: RouteRef = createRouteRef();
export const myVulnerabilitiesRouteRef: RouteRef = createRouteRef();
